import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { CrudService } from '../../../core';
import { Area } from '../area';
import { AreaFilter } from '../filter';

@Injectable({
    providedIn: 'root'
})
export class AreaCrudHttpService {
    resource = 'area';

    constructor(private crudService: CrudService) { }

    /** Procura uma única área através do seu ID */
    find(id: number): Observable<Area> {
        return this.crudService.find<Area>(this.resource, id);
    }

    /** Carrega um única área através do seu ID */
    load(id: number): Observable<Area> {
        return this.crudService.load<Area>(this.resource, id);
    }

    /** Insere um nova área */
    insert(entity: Area): Observable<Area> {
        return this.crudService.insert<Area>(this.resource, entity);
    }

    /** Altera uma área existente */
    update(entity: Area): Observable<Area> {
        return this.crudService.update<Area>(this.resource, entity);
    }

    /** Exclui uma área através do seu ID */
    delete(id: number): Observable<string> {
        return this.crudService.delete(this.resource, id);
    }
}
